import React from 'react';
import { FlyoutMenu } from '.';
import { isMastheadCategoryMenu, isMastheadGalleryMenu, } from '../../../utils/contentful';
import { useActiveSubmenuContext, useActiveSubmenu, } from '../../ActiveSubmenu/ActiveSubmenuProvider';
import { useS4AMastheadContext } from '../../S4AMastheadProvider';
import { ContentfulCategoryMenu } from './MenuLayouts/CategoryMenu/ContentfulCategoryMenu';
import { ContentfulGalleryMenu } from './MenuLayouts/GalleryMenu/ContentfulGalleryMenu';
const useSubmenuItem = (id) => {
    const { mastheadData } = useS4AMastheadContext();
    if (!mastheadData || !mastheadData.fields.header) {
        throw new Error('Masthead data is not available, but is required within the FlyoutSubmenu component.');
    }
    return mastheadData.fields.header
        .fields.centerNav.filter(x => isMastheadCategoryMenu(x) || isMastheadGalleryMenu(x))
        .find(x => {
        return x.sys.id === id;
    });
};
export const isFlyoutSubMenu = (item) => {
    return isMastheadCategoryMenu(item) || isMastheadGalleryMenu(item);
};
export const FlyoutSubmenu = () => {
    const { activeSubmenu } = useActiveSubmenuContext();
    const { clearActiveSubmenu } = useActiveSubmenu(activeSubmenu);
    const activeItem = useSubmenuItem(activeSubmenu);
    return (React.createElement(FlyoutMenu, { opened: activeItem &&
            (isMastheadCategoryMenu(activeItem) ||
                isMastheadGalleryMenu(activeItem))
            ? true
            : false, onClose: clearActiveSubmenu },
        activeItem && isMastheadCategoryMenu(activeItem) && (React.createElement(ContentfulCategoryMenu, { activeItem: activeItem })),
        activeItem && isMastheadGalleryMenu(activeItem) && (React.createElement(ContentfulGalleryMenu, { activeItem: activeItem }))));
};
//# sourceMappingURL=SubMenu.js.map